import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { GruppenDashboardComponent } from './gruppen-dashboard/gruppen-dashboard.component';
import {
    LetzteAktionenPanelComponent,
} from './letzte-aktionen/letzte-aktionen-panel.component';
import { LetzteAktionenTierlisteMenuComponent } from './letzte-aktionen/letzte-aktionen-tierliste-menu.component';
import { LetzteAktionenTierlisteMenuCacheService } from './letzte-aktionen/letzte-aktionen-tierliste-menu-cache.service';
import { DialogsModule } from '../../dialogs/dialogs.module';
import { GoogleChartsModule } from 'angular-google-charts';
import { MatFormFieldModule } from '@angular/material/form-field';
import { GruppenDashboardSelectActionDialogComponent } from './gruppen-dashboard/gruppen-dashboard-select-action-dialog/gruppen-dashboard-select-action-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { DashboardEinstallenStepperDialogComponent } from './dashboard-einstallen-stepper-dialog/dashboard-einstallen-stepper-dialog.component';
import { DashboardSammelstelleDialogComponent } from './dashboard-sammelstelle-dialog/dashboard-sammelstelle-dialog.component';
import { DashboardSammelstelleHerkunftPickDialogComponent } from './dashboard-sammelstelle-dialog/dashboard-sammelstelle-herkunft-pick-dialog.component';
import { DashboardSammelstelleOptionPickDialogComponent } from './dashboard-sammelstelle-dialog/dashboard-sammelstelle-option-pick-dialog.component';
import { GruppenModule as GruppenModuleCore } from '../../../../projects/kiene-core/src/lib/components/gruppen/gruppen.module';
import { KieneAutocompleteModule } from '../../../../projects/kiene-core/src/lib/components/kiene-autocomplete/kiene-autocomplete.module';
import { AusstallenModule } from '../../../../projects/kiene-core/src/lib/components/ausstallen/ausstallen.module';
import { DialogsModule as KieneCoreDialogsModule } from '../../../../projects/kiene-core/src/lib/components/dialogs/dialogs.module';
import { LetzteAktionenDetailDialogComponent } from './letzte-aktionen/letzte-aktionen-detail-dialog/letzte-aktionen-detail-dialog.component';
import { LetzteAktionenTiereDialogComponent } from './letzte-aktionen/letzte-aktionen-tiere-dialog/letzte-aktionen-tiere-dialog.component';
import { DashboardTierlisteHerkunftSetzenDialogComponent } from './letzte-aktionen/dashboard-tierliste-herkunft-setzen-dialog/dashboard-tierliste-herkunft-setzen-dialog.component';
import { MeineKontakteModule } from '../../../../projects/kiene-core/src/lib/components/meine-kontakte/meine-kontakte.module';
import { BetriebskontaktAuswahlModule } from '../../../../projects/kiene-core/src/lib/components/stammdaten/betriebskontakte/betriebskontakt-auswahl.module';
import { BetriebskontaktCardModule } from '../../../../projects/kiene-core/src/lib/components/stammdaten/betriebskontakte/betriebskontakt-card.module';
import { DirectivesModule } from '../../../../projects/kiene-core/src/lib/directives/directives.module';
import { MatDividerModule } from '@angular/material/divider';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { PaesseAbgleichenModule } from '../shared/paesse-abgleichen/paesse-abgleichen.module';
import { GruppeTierModule } from '../../../../projects/kiene-core/src/lib/components/gruppe-tier/gruppe-tier.module';

@NgModule({
    declarations: [
        GruppenDashboardComponent,
        GruppenDashboardSelectActionDialogComponent,
        DashboardEinstallenStepperDialogComponent,
        DashboardSammelstelleDialogComponent,
        DashboardSammelstelleOptionPickDialogComponent,
        DashboardSammelstelleHerkunftPickDialogComponent,
        LetzteAktionenPanelComponent,
        LetzteAktionenTierlisteMenuComponent,
        LetzteAktionenDetailDialogComponent,
        LetzteAktionenTiereDialogComponent,
        DashboardTierlisteHerkunftSetzenDialogComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        GoogleChartsModule,
        MatFormFieldModule,
        MatDialogModule,
        MatButtonModule,
        MatCheckboxModule,
        MatInputModule,
        MatListModule,
        MatIconModule,
        MatPaginatorModule,
        MatStepperModule,
        MatTabsModule,
        MatButtonToggleModule,
        MatMenuModule,
        MatTooltipModule,
        MatCardModule,
        MatSlideToggleModule,
        MatRadioModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        KieneAutocompleteModule,
        GruppenModuleCore,
        AusstallenModule,
        DialogsModule,
        KieneCoreDialogsModule,
        MeineKontakteModule,
        BetriebskontaktAuswahlModule,
        BetriebskontaktCardModule,
        DirectivesModule,
        MatDividerModule,
        MatDatepickerModule,
        PaesseAbgleichenModule,
        GruppeTierModule,
    ],
    exports: [
        GruppenDashboardComponent,
        DashboardEinstallenStepperDialogComponent,
        DashboardSammelstelleDialogComponent,
        LetzteAktionenDetailDialogComponent,
        LetzteAktionenTiereDialogComponent,
        DashboardTierlisteHerkunftSetzenDialogComponent,
    ],
    providers: [LetzteAktionenTierlisteMenuCacheService],
})
export class GruppenDashboardModule {}
